import { useServiceFactory } from '@euler/services/factory';
import { useCallback, useRef, useState } from 'react';
import { biErrorMessage } from '../../functions/biErrors';

export type BiSetDefaultOutcome = { ok: true } | { ok: false; message: string };

/**
 * Makes a dashboard the caller can see their default, one at a time:
 * `settingId` names the one in flight, and a tap while one runs is ignored.
 */
export function useBiSetDefault() {
  const { biService } = useServiceFactory();
  const [settingId, setSettingId] = useState<string | null>(null);
  const busy = useRef(false);
  const setDefault = useCallback(
    async (dashboardId: string): Promise<BiSetDefaultOutcome | null> => {
      if (busy.current) return null;
      busy.current = true;
      setSettingId(dashboardId);
      try {
        await biService.setDefaultDashboard(dashboardId);
        return { ok: true };
      } catch (error) {
        console.error('BI set default dashboard failed', dashboardId, error);
        return {
          ok: false,
          message: biErrorMessage(error, '没有设为默认，请稍后重试。'),
        };
      } finally {
        busy.current = false;
        setSettingId(null);
      }
    },
    [biService],
  );
  return { setDefault, settingId };
}
